export enum AxisEnum {
    X = 'x',
    Y = 'y',
    Both = 'both',
}
